<template>
    <div class='week-picker'>
        <span v-for="week in weeks"
            :key="week.id"
            :class="{
                'is-selected': weekCache.includes(week.id)
            }"
            @click="saveWeek(week)">{{ week.name }}</span>
    </div>
</template>

<script>
import { createComponent } from '@vue/composition-api'

export default createComponent({
    props: {
        weekCache: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            weeks: [{
                id: 1,
                name: '周一'
            }, {
                id: 2,
                name: '周二'
            }, {
                id: 3,
                name: '周三'
            }, {
                id: 4,
                name: '周四'
            }, {
                id: 5,
                name: '周五'
            }, {
                id: 6,
                name: '周六'
            }, {
                id: 7,
                name: '周日'
            }]
        }
    },

    methods: {
        setWeekCache(weekCache) {
            this.$emit('update:weekCache', weekCache)
        },

        sortWeekCache(weekCache) {
            const wCache = weekCache.sort((a, b) => a - b)
            this.setWeekCache(wCache)
        },

        saveWeek(week) {
            let cache
            const curWeekId = this.weekCache.find(w => w === week.id)
            if (curWeekId != null) {
                cache = this.weekCache.filter(w => w !== curWeekId)
            } else {
                cache = this.weekCache.concat(week.id)
            }
            this.sortWeekCache(cache)
        }
    }
})
</script>

<style lang="scss" scoped>
.week-picker {
    display: flex;
    font-size: 14px;

    span {
        flex: 0 0 40px;
        height: 40px;
        line-height: 40px;
        margin-left: 8px;
        border-radius: 4px;
        text-align: center;
        color: #999;
        background-color: #fff;
        border: 1px solid #ddd;
        cursor: pointer;
        ;
        transition: all .25s;

        &.is-selected {
            background-color: #cceae7;
            border-color: #cceae7;
            color: #009688;
            font-weight: 600;
        }

        &:first-child {
            margin-left: 0;
        }
    }
}
</style>
